import React, {useState, useEffect, useMemo} from "react"
import {Outlet} from "react-router-dom"

import * as actions from "../../actions"

import {useParams} from "react-router-dom"
import {PayeeStoreContext} from "../../contexts/PayeeStoreContext"
import { useSelector, useDispatch } from "react-redux";

import {DOMINICA_COUNTRY_ID} from "../../constants/country"
function PayeeStoreLayout ({}) {
    const { catalogHandleId, payeeHandleId } = useParams();
    const payeeId = useSelector(state => state.payees.payeeIdByHandleId[payeeHandleId] || "");
    const payee = useSelector(state => state.payees.payeesById[payeeId])
    const payeeCatalogId = useSelector(state => payeeId && catalogHandleId && 
                                                state.payeeCatalogs.payeeCatalogIdByPayeeCatalogHandleId[payeeId] &&
                                                state.payeeCatalogs.payeeCatalogIdByPayeeCatalogHandleId[payeeId][catalogHandleId]
                                                ? 
                                                state.payeeCatalogs.payeeCatalogIdByPayeeCatalogHandleId[payeeId][catalogHandleId]
                                                :
                                                ""
                     )
    const cartId = useSelector(state => state.carts.cartIdByPayeeId[payeeId] || "");
    /* record a view of the payee catalog */
    const dispatch = useDispatch();
    useEffect(() => {
        if (payeeCatalogId) dispatch(actions.callViewPayeeCatalog(payeeCatalogId))
    }, [payeeCatalogId, dispatch])
    /** listen to catalog indicated by the catalogHandleId from the url params **/
    const [catalogListener, setCatalogListener] = useState(()=>()=>{})
    //track loading of the  catalog to know whether it does not exist or is just not yet loaded
    const [catalogLoaded, setCatalogLoaded] = useState(null)
    //listen to the catalog anytime the catalogHandleId changes
    const listenToCatalog = async () => {
        if (!payeeId || !payeeCatalogId) dispatch(actions.toggleLoading(true))
        dispatch(actions.httpFetchSavePayeeCatalogByHandleId(catalogHandleId, payeeId, () => setCatalogLoaded(true)))
        const newCatalogListener = await dispatch(actions.fetchSubscribeToPayeeCatalogByHandleId(catalogHandleId, payeeId, () => setCatalogLoaded(true)))
        setCatalogListener(() => newCatalogListener)
    }
    useEffect(() => {
        if (payeeId && catalogHandleId) listenToCatalog()
        return () => {
            if (typeof catalogListener === "function") catalogListener()
        }
    }, [catalogHandleId, payeeId])
    /** listen to payee indicated by the payeeHandleId from the url params **/
    const [payeeListener, setPayeeListener] = useState(()=>()=>{})
    //track loading of payee to know if payee does not exist or is just not yet loaded
    const [payeeLoaded, setPayeeLoaded] = useState(null)
    //listen to they payee anytime the payee handle id changes
    const listenToPayee = async () => {
        //listen to payee by also load it directly for speed
        if (!payee) dispatch(actions.toggleLoading(true))
        dispatch(actions.httpFetchSaveMerchantPayeeByHandleId(payeeHandleId, () => setPayeeLoaded(true)))
        const newPayeeListener = await dispatch(actions.fetchSubscribeToMerchantPayeeByHandleId(payeeHandleId, () => setPayeeLoaded(true)))
        setPayeeListener(() => newPayeeListener)
    }
    useEffect(() => {
        if (payeeHandleId) listenToPayee()
        return () => {
            if (typeof payeeListener === "function") payeeListener()
        }
    }, [payeeHandleId])
    /** listen to products attached to the catalog **/
    const [productsListener, setProductsListener] = useState(()=>()=>{})
    const listenToProducts = async () => {
        dispatch(actions.httpFetchSavePayeeProductsForPayeeCatalog(payeeCatalogId))
        const newProductsListener = await dispatch(actions.fetchSubscribeToPayeeProductsForPayeeCatalog(payeeCatalogId))
        setProductsListener(() => newProductsListener)
    }
    useEffect(() => {
        if (payeeCatalogId) listenToProducts()
        return () => {
            if (typeof productsListener === "function") productsListener()
        }
    }, [payeeCatalogId])
    /** load the country that this payee is registered in **/
    const registeredCountryId = payee && payee.registeredCountryId ? payee.registeredCountryId : DOMINICA_COUNTRY_ID
    useEffect(() => {
        if (registeredCountryId) {
            dispatch(actions.httpFetchSaveCountry(registeredCountryId))
        }
    }, [registeredCountryId])
    /** ensure the app cannot be in a permanently loading state **/
    useEffect(() => {
        if (catalogLoaded && payeeLoaded) {
            dispatch(actions.toggleLoading(false))
        }
    }, [catalogLoaded, payeeLoaded])
    useEffect(() => {
        return () => {
            dispatch(actions.toggleLoading(false))
        }
    }, [])
    /** 
     * provide a context to all child elements with payee id, catalog id and cart id. 
     * This ensures that no children need to recalculate the value 
    **/
    const contextValue = useMemo(() => ({ payeeId, payeeLoaded, payeeCatalogId, catalogLoaded, cartId}), [payeeId, payeeLoaded, payeeCatalogId, catalogLoaded, cartId]);
    return (
        <PayeeStoreContext.Provider value={contextValue}>
            <div className="main">
                <Outlet />
            </div>
        </PayeeStoreContext.Provider>
    )
}


export default PayeeStoreLayout